import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { Datatable, DatatableOptions } from '../../Widgets/Datatable'

var tableId = "tableOperations";
var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

export interface DetailPageOptions extends PageOptionsBase {
    urlList: string;
    urlOperationDetail: string;
    urlCustomerDetail: string;
    localizer: {
        StatusEnabled: string;
        StatusDisabled: string;
        DetailsLink: string;
    }
}

export class DetailPage extends PageBase<DetailPageOptions> {
    private _tableOptions: DatatableOptions;
    private _table: Datatable;

    constructor(options: DetailPageOptions) {
        super(options);
        var getOperationDetailUrl = (rowData: any): string => (`${options.urlOperationDetail}/${rowData.OperationId}`);
        var getCustomerDetailUrl = (rowData: any): string => (`${options.urlCustomerDetail}/${rowData.CustomerId}`);
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'Id',
            autoWidth: true,
            ordering: false,
            columns: [
                {
                    data: "CustomerName",
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkCustomerName${rowData.CustomerId}' href='${getCustomerDetailUrl(rowData)}'>${data}</a>`)
                },
                {
                    data: "CustomerStatus",
                    render: (data: any, type: any, rowData: any) => {
                        //var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
                        var css = `status-${data.toLowerCase()}`;
                        return `<span id='spnState${rowData.OperationId}' class='${css}'>${data}</span>`;
                    }
                },
                {
                    data: 'OperationName',
                    className: "bold",
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkName${rowData.OperationId}' href='${getOperationDetailUrl(rowData)}'>${data}</a>`)
                },
                {
                    data: "OperationStatus",
                    render: (data: any, type: any, rowData: any) => {
                        //var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
                        var css = `status-${data.toLowerCase()}`;
                        return `<span id='spnState${rowData.OperationId}' class='${css}'>${data}</span>`;
                    }
                },
                {
                    data: '',
                    sortable: false,
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkDetail${rowData.OperationId}' href='${getOperationDetailUrl(rowData)}'>${options.localizer.DetailsLink}</a>`)
                }
            ]
        };
    }

    init(): void {
        this._table = new Datatable(tableId, this._tableOptions);
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/Jurisdictions/DetailPage.ts
 **/